import { styled } from "@mui/material/styles";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { Box } from "@mui/material";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 12,
  width: "100%",
  borderRadius: 16,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 16,
    backgroundColor: theme.palette.success.main,
    height: 12,
  },
}));

interface SubmoduleProgressIndicatorProps {
  percentage: number;
}

export const SubmoduleProgressIndicator = ({
  percentage,
}: SubmoduleProgressIndicatorProps) => {
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <BorderLinearProgress variant="determinate" value={Math.round(percentage)} />
      </Box>
    </>
  );
};
